import {Checkbox as ArkCheckbox} from '@ark-ui/react/checkbox'
import Icon from '~/components/icon'
import {getCheckboxIconName} from '~/components/checkbox/helpers'
import './index.less'

export const CheckboxControl = () => {
	return (
		<ArkCheckbox.Control className="checkbox-control">
			<ArkCheckbox.Indicator>
				<Icon name={getCheckboxIconName('checked')} />
			</ArkCheckbox.Indicator>
			<ArkCheckbox.Indicator indeterminate>
				<Icon name={getCheckboxIconName('indeterminate')} />
			</ArkCheckbox.Indicator>
		</ArkCheckbox.Control>
	)
}
